import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";

export const TemplateIdContext = createContext<{
  templateId: string;
  setTemplateId: Dispatch<SetStateAction<string>>;
  templateType: string;
  setTemplateType: Dispatch<SetStateAction<string>>;
}>({
  templateId: "",
  setTemplateId: () => ({}),
  templateType: "",
  setTemplateType: () => ({}),
});

export const TemplateIdContextProvider = ({ children }: { children: ReactNode }) => {
  const [templateId, setTemplateId] = useState<string>("");
  const [templateType, setTemplateType] = useState<string>("");

  return (
    <TemplateIdContext.Provider
      value={{
        templateId,
        setTemplateId,
        templateType,
        setTemplateType,
      }}
    >
      {children}
    </TemplateIdContext.Provider>
  );
};
